import React from "react";

const WebPages_Forms = () => {
  return (
    <div className="tutorial-page">
      <h1>WebPages Forms</h1>
      <p>This is the WebPages Forms page content.</p>
    </div>
  );
};

export default WebPages_Forms;
